module.exports = "<user-edit></user-edit>"